import { useContextState } from "../../../../../../../../../../hooks/theme"



const useStyles = () => {
    const { colors } = useContextState()
    return {
        title: {
            fontWeight: 'bold'
        },
        containerActivity: {
            maxHeight: '100%',
            overflow: 'auto',
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": {
              display: "none",
            }
        },
        displayFlex:{
            display: 'flex', 
            flexDirection: 'column', 
            '&.gp4':{
                gap: 4
            },
            '&.gp2':{
                gap: 2
            }
        },
        optionsContainer: {
            padding: '0px 20px',
            height:'100%',
            maxHeight:'820px',
            flexGrow: 1,
        },
        conteinerButton:{
            display:'flex',
            justifyContent:'space-between',
            '& .MuiButtonBase-root':{
                border: `1px solid ${colors.color4}`
            }
        },
        detinationContainer: {
            border:`1px solid ${colors.color13}`,
            borderRadius:'8px',
            display:'flex',
            flexDirection:'column',
            gap:2, 
            padding:2, 
            '& .MuiTypography-root':{
                color: colors.color13,
            },
            '& .bold':{
                fontWeight:'bold'
            },
        },
        lattitudeContainer: {
            display:'flex',
            flexWrap:'wrap',
            gap:1,
            '& .wdth':{
                width:'136px',
                wordWrap: 'break-word',
            }
        },
        buttonWithoutBorder: {
            display:'flex',
            justifyContent:'space-between',
        },
        filters:{
            position:'relative',
            padding:3,
            border: `1px solid ${colors.color13}`,
            borderRadius:1,
            '& .MuiFormControlLabel-label': {
                color: colors.color13,
            }
        },
        switch: {
            '& .MuiFormControlLabel-label': {
                color: colors.color13,
            }
        },
        cleanFilters: {
            position:'absolute',
            left:'120px',
            top:'-60px',
        },
        map: { 
            height: '100%', 
            width: '100%' 
        },
        mapModal:{
            width: '60vw',
            padding: 2,
            height: '600px',
        },
        containerDate: {
            display:'flex',
            gap:'20px'
        },
        table: ({row}:{row:boolean}) => ({
          '& .MuiPaper-root':{
            height: row ? '400px':'40px',
            width:'100%'
          }
        })
    }
}

export { useStyles }
